import { MoreHorizontal, Edit, Trash2, Flag } from 'lucide-react';
import { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const PostMenu = ({ post, isOwner, onEdit, onDelete }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button 
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          data-testid={`post-menu-${post.id}`}
        >
          <MoreHorizontal className="w-5 h-5 text-gray-600" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {isOwner ? (
          <>
            <DropdownMenuItem onClick={onEdit} className="cursor-pointer" data-testid="edit-post-btn">
              <Edit className="w-4 h-4 mr-2" />
              Edit Post
            </DropdownMenuItem>
            <DropdownMenuItem onClick={onDelete} className="cursor-pointer text-red-600" data-testid="delete-post-btn">
              <Trash2 className="w-4 h-4 mr-2" />
              Delete Post
            </DropdownMenuItem>
          </>
        ) : (
          <DropdownMenuItem className="cursor-pointer text-red-600" data-testid="report-post-btn">
            <Flag className="w-4 h-4 mr-2" />
            Report Post
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PostMenu;
